import React from 'react';
import {Button, Space} from 'antd';
import {WelcomeHeader} from './WelcomeHeader';
import {LogoutButton} from '@app/screensComponents/HomeScreen/MainHome/SideMenu/LogoutButton';
import {HeartPulse} from 'lucide-react';
import {GREEN_700} from '@app/style/GlobalColors';

const HeaderLayout = () => {
  return (
    <Space
      direction={'horizontal'}
      className={'h-20 bg-green-50 flex justify-between items-center px-4'}
    >
      <div className={'flex items-center gap-2'}>
        <HeartPulse size={50} />
        <WelcomeHeader />
      </div>
      <Button style={{color:'white', backgroundColor: GREEN_700}}>
        <LogoutButton />
      </Button>
    </Space>

  );
};

export default HeaderLayout;
